/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Agents_AnswerInputs */

const en_faq_agents_answer = /** @type {(inputs: Faq_Agents_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. We design and build custom AI agents for a specific job: answering customer questions, following up on leads, processing documents or keeping your CRM up to date. Each agent works from your own data, uses only the tools it is given, and hands anything outside its rules to a named person on your team.`)
};

const lv_faq_agents_answer = /** @type {(inputs: Faq_Agents_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā. Projektējam un izstrādājam AI aģentus konkrētam darbam: atbilžu sagatavošanai klientiem, pārdošanas sarunu turpināšanai, dokumentu apstrādei vai CRM uzturēšanai. Katrs aģents strādā ar Jūsu datiem, izmanto tikai tam piešķirtos rīkus un gadījumus ārpus noteikumiem nodod konkrētam cilvēkam Jūsu komandā.`)
};

/**
* | output |
* | --- |
* | "Yes. We design and build custom AI agents for a specific job: answering customer questions, following up on leads, processing documents or keeping your CRM u..." |
*
* @param {Faq_Agents_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_agents_answer = /** @type {((inputs?: Faq_Agents_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Agents_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_agents_answer(inputs)
	return en_faq_agents_answer(inputs)
});